import Utils from '../utils'
import parseUrl from 'tld-extract'
import LogoWeShare from '../assets/logo-weshare.png'
import LogoIndosuez from '../assets/logo-indosuez.svg'
import LogoMyDocBase from '../assets/logo-mydocbase.png'

/**
 * Parse an html string and return an object with all the metadata it could find
 */
const extractMetadata = (htmlStr) => {
  let parser = new DOMParser()
  let html = parser.parseFromString(htmlStr, 'text/html')
  let metas = html.querySelectorAll('meta')
  return Array.from(metas).reduce((acc, meta) => {
    const property = meta.getAttribute('property') || meta.getAttribute('name')
    if (property != null) {
      acc[property] = meta.getAttribute('content')
    }
    return acc
  }, {})
}

/**
 * Retrieve a metadata, and try with common prefix if not found
 */
const getMetadata = (data, field, defaultValue) => {
  // find commons fields
  let value = data[field] || data[`og:${field}`] || data[`twitter:${field}`]
  value = (value || '').trim()
  // default value if empty
  return value || defaultValue
}

/**
 * Build a metadata object
 * - handle relative url for image
 * - return null if all values are empty
 */
const buildMetadata = (data, url, defaultMetadata = {}) => {
  const metadata = {
    title: getMetadata(data, 'title', defaultMetadata.title),
    description: getMetadata(data, 'description', defaultMetadata.description),
    image: buildAbsoluteUrl(getMetadata(data, 'image'), url) || defaultMetadata.image,
    url: url
  }
  if (Utils.isBlank(metadata.title) && Utils.isBlank(metadata.description) && Utils.isBlank(metadata.image)) {
    return null
  }
  return metadata
}

/**
 * Check if the given path is a relative or absolute url, and makes it an absolute one
 */
const buildAbsoluteUrl = (path, baseUrl) => {
  if (Utils.isBlank(path)) {
    return null
  }
  let checkAbsolute = new RegExp('^(?:[a-z]+:)?//', 'i')
  return checkAbsolute.test(path) ? path : baseUrl + '/' + path
}

/**
 * Build a metadata object by extracting information from the url. No real metadata involved here
 */
const buildFakeMetadata = (url, defaultTitle, image) => {
  const dataUrl = parseUrl(url) || { sub: defaultTitle }
  const title = formatSubDomains(dataUrl.sub)
  return {
    title: title,
    description: url,
    image: image,
    url: url
  }
}

const buildFakeIndosuezMetadata = url => {
  const imageMap = {
    'intranet.ca-indosuez.com': LogoWeShare,
    'mydocbase.ca-indosuez.com': LogoMyDocBase,
    'ca-indosuez.com': LogoIndosuez
  }
  const uri = Object.keys(imageMap).find((key) => url.includes(key))
  return buildFakeMetadata(url, 'Indosuez', imageMap[uri])
}

/**
 * `sub-domain` => `Sub Domain`
 */
const formatSubDomain = part => part
  .split(/[-_]+/)
  .map(value => value.charAt(0).toUpperCase() + value.slice(1))
  .join(' ')

/**
 * `sub.domain` => `Sub - Domain`
 * `sub-domain.domain` => `Sub Domain - Domain`
 */
const formatSubDomains = subDomains => subDomains
  .split('.')
  .map(formatSubDomain)
  .join(' - ')

export default {
  extractMetadata,
  buildMetadata,
  buildFakeMetadata,
  buildFakeIndosuezMetadata
}
